module.exports = __webpack_public_path__ + "static/img/zuocelogo.485871b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/zuocelogo.png
// module id = H8p/
// module chunks = 1